import { render, staticRenderFns } from "./EnterpriseDetailsGeneralData.vue?vue&type=template&id=1fb4eeb0&"
import script from "./EnterpriseDetailsGeneralData.vue?vue&type=script&lang=js&"
export * from "./EnterpriseDetailsGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports